const modalTypes = {
    ADD_MODAL: 'ADD_MODAL',
  };
  
  export default modalTypes;